<template>
    <set-oracle-credentials-dialog
        :value="value"
        @input="$emit('input', $event)"
        :loading="$wait.is('creatingOracleAccount')"
    >
        <template #activator="bindings">
            <slot name="activator" v-bind="bindings"></slot>
        </template>
        <template #actions="{ form, formId, isValid, clear, close }">
            <post-cloud-account-button
                :value="{ ...form, Type: 'Oracle' }"
                :clear="clear"
                :valid="isValid"
                :form="formId"
                v-wait-while="'creatingOracleAccount'"
                @http2xx="close().then(() => $emit('http2xx', $event))"
            ></post-cloud-account-button>
        </template>
    </set-oracle-credentials-dialog>
</template>

<script>
import SetOracleCredentialsDialog from '@/components/Settings.CloudAccounts/Oracle/SetOracleCredentialsDialog.vue';
import PostCloudAccountButton from '@/components/Settings.CloudAccounts/PostCloudAccountButton';
export default {
    components: { SetOracleCredentialsDialog, PostCloudAccountButton },
    props: {
        value: Boolean,
    },
};
</script>